import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function OutlookCallback() {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');

        if (window.opener) {
            window.opener.postMessage(
                { type: 'outlook-oauth-callback', code, state, error },
                window.location.origin
            );
            window.close();
        }
    }, [searchParams]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4" />
                <p className="text-gray-600">Connecting your Outlook account...</p>
            </div>
        </div>
    );
}
